import type { CoverageAsset as ApiCoverageAsset } from "@/react/features/coverage/api/types";
import type {
  CoverageStrength,
  CoverageSequence,
} from "@/react/features/coverage/api/types";

export type BucketStatus = CoverageStrength;

export type SequenceStatus = CoverageSequence;

/** UI-facing asset (camelCase) from Coverage assets API. */
export interface CoverageAsset {
  id: number;
  fileId: number;
  url?: string | null;
  thumbnailUrl?: string | null;
  caption: string;
  altText: string;
  tagIds: number[];
}

export interface BucketFill {
  tagId: number;
  label: string;
  assetCount: number;
  status: BucketStatus;
  assets: CoverageAsset[];
}

export interface ProblemHub {
  id: string;
  name: string;
  description: string | null;
  buckets: BucketFill[];
  sequenceStatus: SequenceStatus;
  filledRequired: number;
  totalRequired: number;
  overallStatus: BucketStatus;
  /** Hub list progress — always from API `progress_percent`. */
  progressPercent: number;
  temporalAssets: {
    before: CoverageAsset[];
    during: CoverageAsset[];
    after: CoverageAsset[];
  };
}

export function mapApiAsset(raw: ApiCoverageAsset): CoverageAsset {
  return {
    id: raw.id,
    fileId: raw.file_id,
    url: raw.url,
    thumbnailUrl: raw.thumbnail_url,
    caption: raw.caption ?? "",
    altText: raw.alt_text ?? "",
    tagIds: raw.tag_ids ?? [],
  };
}
